import { webhookDashboardSlice } from '../slices/webhookDashboardSlice';

export default webhookDashboardSlice.reducer;
